import { createContext } from "react-router";

export const routerSessionContext = createContext({});
